import React, { Fragment } from 'react';
import { Card } from '../../../components/ui/Card';
import { TabNavigation } from '../../../components/operations/TabNavigation';
import { OperationsSwitcher } from '../../../components/operations/OperationsSwitcher';
const LOCATION_TABS = [{
  label: 'Overview',
  path: ''
}, {
  label: 'Capacity',
  path: 'capacity'
}, {
  label: 'Performance',
  path: 'performance'
}, {
  label: 'Costs',
  path: 'costs'
}, {
  label: 'Settings',
  path: 'settings'
}];
const STATION_STATS = [{
  name: 'Burgeri',
  icon: '🍔',
  orders: 847,
  capacity: 68,
  prep: '8.2 min',
  peak: '14:00 (92%)'
}, {
  name: 'Palačinke',
  icon: '🥞',
  orders: 412,
  capacity: 52,
  prep: '5.8 min',
  peak: '20:00 (78%)'
}, {
  name: 'Pakovanje',
  icon: '📦',
  orders: 1259,
  capacity: 48,
  prep: '2.1 min',
  peak: '14:00 (71%)'
}, {
  name: 'Salate',
  icon: '🥗',
  orders: 156,
  capacity: 42,
  prep: '4.9 min',
  peak: '13:00 (65%)'
}, {
  name: 'Giros',
  icon: '🌯',
  orders: 89,
  capacity: 59,
  prep: '7.4 min',
  peak: '21:00 (88%)',
  warning: true
}];
export function Performance() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1939">
      <h1 className="text-2xl font-bold text-text-primary" data-id="element-1940">
        Location Performance
      </h1>

      <OperationsSwitcher data-id="element-1941" />

      <TabNavigation tabs={LOCATION_TABS} basePath="/operations/locations" data-id="element-1942" />

      <Card noPadding data-id="element-1943">
        <div className="p-4 border-b border-white/10 font-bold" data-id="element-1944">
          Station Breakdown
        </div>
        <div className="overflow-x-auto" data-id="element-1945">
          <table className="w-full text-sm" data-id="element-1946">
            <thead data-id="element-1947">
              <tr className="text-text-secondary border-b border-white/5" data-id="element-1948">
                <th className="text-left p-4" data-id="element-1949">STATION</th>
                <th className="text-center p-4" data-id="element-1950">ORDERS</th>
                <th className="text-left p-4 w-1/3" data-id="element-1951">CAPACITY USED</th>
                <th className="text-center p-4" data-id="element-1952">AVG PREP</th>
                <th className="text-left p-4" data-id="element-1953">PEAK HOUR</th>
              </tr>
            </thead>
            <tbody data-id="element-1954">
              {STATION_STATS.map(stat => <tr key={stat.name} className="border-b border-white/5 hover:bg-white/5" data-id="element-1955">
                  <td className="p-4 font-medium flex items-center gap-2" data-id="element-1956">
                    <span data-id="element-1957">{stat.icon}</span> {stat.name}
                  </td>
                  <td className="p-4 text-center" data-id="element-1958">{stat.orders}</td>
                  <td className="p-4" data-id="element-1959">
                    <div className="flex items-center gap-3" data-id="element-1960">
                      <span className="text-xs font-bold w-8" data-id="element-1961">
                        {stat.capacity}%
                      </span>
                      <div className="flex-1 h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-1962">
                        <div className={`h-full ${stat.capacity > 80 ? 'bg-accent-error' : stat.capacity > 60 ? 'bg-accent-warning' : 'bg-accent-success'}`} style={{
                      width: `${stat.capacity}%`
                    }} data-id="element-1963"></div>
                      </div>
                    </div>
                  </td>
                  <td className="p-4 text-center" data-id="element-1964">{stat.prep}</td>
                  <td className="p-4 flex items-center gap-2" data-id="element-1965">
                    {stat.peak}
                    {stat.warning && <span className="text-accent-warning" data-id="element-1966">⚠️</span>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <Card data-id="element-1967">
        <h3 className="font-bold mb-4" data-id="element-1968">Capacity Utilization Heatmap</h3>
        <div className="overflow-x-auto" data-id="element-1969">
          <div className="min-w-[600px]" data-id="element-1970">
            <div className="grid grid-cols-[60px_repeat(11,1fr)] gap-1 text-xs" data-id="element-1971">
              <div className="text-text-secondary" data-id="element-1972"></div>
              {[10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map(h => <div key={h} className="text-center text-text-secondary" data-id="element-1973">
                  {h}h
                </div>)}

              {['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'].map(day => <Fragment key={day} data-id="element-1974">
                  <div className="font-bold text-text-secondary py-2" data-id="element-1975">
                    {day}
                  </div>
                  {[...Array(11)].map((_, i) => {
                // Mock random intensity
                const intensity = Math.random();
                const bg = intensity > 0.8 ? 'bg-white/40' : intensity > 0.5 ? 'bg-white/20' : 'bg-white/5';
                return <div key={i} className={`rounded ${bg} h-8`} data-id="element-1976"></div>;
              })}
                </Fragment>)}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-4 mt-4 text-xs text-text-secondary justify-end" data-id="element-1977">
          <div className="flex items-center gap-1" data-id="element-1978">
            <div className="w-3 h-3 bg-white/5 rounded" data-id="element-1979"></div> &lt;50%
          </div>
          <div className="flex items-center gap-1" data-id="element-1980">
            <div className="w-3 h-3 bg-white/20 rounded" data-id="element-1981"></div> 50-80%
          </div>
          <div className="flex items-center gap-1" data-id="element-1982">
            <div className="w-3 h-3 bg-white/40 rounded" data-id="element-1983"></div> &gt;80%
          </div>
        </div>
      </Card>
    </div>;
}